import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction, LazyImport } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "YammerPrebootstrap" */ "./lazyIndex"), { name: "YammerPrebootstrap" });

// Export lazy actions
export const lazyInitializeConfigForYammer: LazyAction<typeof lazyIndex.initializeConfigForYammer, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeConfigForYammer);

export const lazyVivaEngageIconOutline: LazyImport<typeof lazyIndex.VivaEngageIconOutline, typeof lazyModule> = new LazyImport(lazyModule, m => m.VivaEngageIconOutline);
